export default {
    en: {
        id: 'diagram4b2-10',
        blocks: [
            {
                index: '1',
                task: 'S = Product developers constantly strive to keep quality and cost in line with demands for faster delivery',
                title: "S = "
            },
            {
                index: '2',
                task: 'C = Still get schedule slippages, “firefighting,” and inferior quality',
                title: "C = "
            },
            {
                index: '3',
                task: 'Q = Adopt integrated, holistic approach',
                title: "Q = "
            },
            {
              index: '4',
              task: '',
              title: "A =",
            },
        ],
        answers: [
            {
                index: '3',
                title: 'What do?'
            },
            {
                index: '1',
                title: 'Want to achieve X plus Y and Z'
            },
            {
                index: '2',
                title: 'Don’t achieve'
            },
            {
                index: '4',
                title: 'Change approach'
            },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 3,
        note: `
            You can see easily that the Complication is wrong here: it breaks the rule that you cannot put your thinking in the introduction. Here it falls into the trap of including information that the reader might not know or agree with in advance – that the problem is managers making isolated improvements instead of looking at the process as a dynamic whole. That insight resulted from his analysis and thus belongs below, in the body. In fact, it is his main point. The problem is actually that all the parts of the process are intertwined.
            <div class="scq__note">
                <div>
                    <span>S = Want to do X, Y, Z, but can’t</span>
                    <span>Approach problem by doing A B C</span>
                </div>
                <div>
                    <span>C = Problem is all three parts intertwined</span>
                    <span>Doesn’t work</span>
                </div>
                <div>
                    <span>Q = What do?</span>
                    <span>How change</span>
                </div>
                <div>
                    <span>A = Make those parts work together</span>
                    <span>Adopt X Y Z approach</span>
                </div>
            </div>
            Getting the statement of the SCQ down to its simplest lets you see how silly the logic is: they don’t use the right approach, so the answer is to use the right approach
        `,
      noteHeight: '300px',
      noteTitle: '139px'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise10.js